/*
 * @Author       : LiYang
 * @Date         : 2021-10-11 18:44:25
 * @LastEditTime : 2021-12-23 21:09:02
 * @LastEditors  : Please set LastEditors
 * @Description  : 类型判断集合
 */

import { curry } from './functional'

export const getType = input => Object.prototype.toString.call(input).slice(8, -1).toLocaleLowerCase()

export const is = curry(2, (type, input) => getType(input) === type)

export const isArray = Array.isArray || is('array');

export const isString = is('string')

export const isNumber = is('number')

export const isBoolean = is('boolean')

export const isFunction = is('function')

export const isPromise = is('promise')

export const isNull = is('null')

export const isUndef = input => input === undefined

export const isDef = input => input !== undefined && input !== null

export const isDate = is('date')

export const isObject = is('object')

export const isTrue = input => input === true

export const isFalse = input => input === false